module.exports = __webpack_public_path__ + "media/images/l_logo-b7acf734009abc93e19847b8d8c2cfc8.png";